<template>
    <div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.ongoing_applications)}}</h4>
        	</div>
			
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-30">
							<form-input v-model="search.text" :label="locale.search_keyword" type="text" @keyup.enter="searchHandler()"/>
						</div>
						<div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-size-25">
							<form-select v-model="search.status" :label="locale.status" :list="status_list" />
						</div>
						<div class="md-layout-item md-xsmall-size-50 md-small-size-50 md-size-25">
							<form-select v-model="search.unit" :label="locale.reviewing_unit" :list="unit_list" />
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-20" style="margin-top: 18px">
							<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%"><i class="material-icons button-icon">manage_search</i> {{translate(locale.search)}}</md-button>
						</div>
						
					</div>
				</container>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px" v-if="loaded && application_list.length === 0">
				<container>
					<p class="text-center text-primary" style="margin: 10px 0;"><b>{{translate(locale.no_ongoing)}}</b></p>
				</container>
        	</div>
			

			<template v-if="application_list.length > 0">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 show-web">
					<div class="application-card">
						<div class="application-no"><b>{{translate(locale.no)}}</b></div>
						<div class="application-content">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-50">
									<p class="application-text"><b>{{translate(locale.code_and_project)}}</b></p>
								</div>
								<div class="md-layout-item md-xsmall-size-50 md-small-size-100 md-medium-size-20 md-size-20">
									<p class="application-text"><b>{{translate(locale.reviewing)}}</b></p>
								</div>
								<div class="md-layout-item md-xsmall-size-50 md-small-size-100 md-medium-size-20 md-size-20">
									<p class="application-text"><b>{{translate(locale.status_and_created)}}</b></p>
								</div>
								<div class="md-layout-item md-xsmall-size-50 md-small-size-100 md-medium-size-10 md-size-10 text-right">
									<p class="application-text"><b>{{translate(locale.action)}}</b></p>
								</div>
							</div>
						</div>
					</div>
				</div>
	
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(application, index) in application_list">
					<div class="application-card">
						<div class="application-no"><b>{{index+1}}</b></div>
						<div class="application-content">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-50 application-column">
									<p class="application-text"><b>#{{application.hash}} ({{application.main_researcher}})</b><br>{{application.project_title}}</p>
								</div>
								<div class="md-layout-item md-xsmall-size-50 md-small-size-33 md-medium-size-20 md-size-20 application-column">
									<p class="application-text"><b>{{translate(locale.waiting)}} <span v-if="application.unit_name">{{application.unit_name}}</span><span v-else>{{translate(locale.applicant)}}</span></b><br>{{translate(locale.waiting)}}{{translate(config.timelify(application.updated_date))}}</p>
								</div>
								<div class="md-layout-item md-xsmall-size-50 md-small-size-33 md-medium-size-20 md-size-20 application-column">
									<p class="application-text"><b>{{translate(config.getStatus(application.status))}}</b><br>{{translate(config.datelify(application.created_date))}}</p>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-33 md-medium-size-10 md-size-10 application-column application-action">
									<router-link :to="'/ongoing_applications/detail/' + application.hash" ><md-button class="md-raised md-secondary" style="padding: 0"><i class="material-icons button-icon">visibility</i> {{translate(locale.viewMore)}}</md-button></router-link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right" v-if="loadMore">
					<md-button class="md-raised md-primary" @click="searchHandler(true)"><i class="material-icons button-icon">refresh</i> {{translate(locale.listMore)}}</md-button>
				</div>
			</template>
        </div>
    </div>
</template>

<script>
	export default {
		created() {
			this.getSettings();
			this.searchHandler();
		},
		data() {
			return {
				loaded: false,
				application_list: [],
				search: {text: "", status: "", unit: "" },
				status_list: [{id: "", name: "All"}],
				unit_list: [{id: "", name: "All"}],
				limit: 50
			}
		},
		methods: {
			getSettings() {
				this.$http.get(`${this.config.api}/user/setting/get/search`).then(data => {
					this.unit_list = this.unit_list.concat(data.body.data.unit_list);
					this.status_list = this.status_list.concat(data.body.data.status_list);
				})
			},
			searchHandler(more = false) {
				let offset = more ? this.application_list.length : 0;
				this.$http.post(`${this.config.api}/user/application/get_ongoing`, {
					text: this.search.text,
					status: this.search.status,
					unit: this.search.unit,
					limit: this.limit, 
					offset: offset
				}).then(data => {
					if (data.body.data.length == this.limit) this.loadMore = true;
					else this.loadMore = false;
					this.application_list = more ? this.application_list.concat(data.body.data) : data.body.data;
					this.loaded = true;
				})
			}
		}
	}
</script>

<style>
	.application-card {
		display: flex;
		flex-direction: row;
		box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
		-webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
		background-color: #FFF;
		padding: 12px 0 12px 12px;
		border-radius: 6px;
		margin-bottom: 15px;
		color: #353690;
		border: 2px solid transparent;
		/* transition-duration: 0.2s; */
	}
	/* .application-card:hover {
		border: 2px solid #353690;
	} */
	.application-image {
		width: 60px;
		margin-right: 15px;
	}
	.application-no {
		width: 40px;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.application-column {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.application-text {
		margin-bottom: 0;
	}
	.application-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex-grow: 1;
	}
	.application-button {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.application-action {
		display: flex;
		flex-direction: row;
		justify-content: right;
	}
</style>


// WEBPACK FOOTER //
// src/pages/OngoingApplications/View.vue